<template>
  <PreviewImage v-bind="getBindValue" />
</template>

<script setup lang="ts">
  import { computed, useAttrs } from 'vue';
  import { isArray, omit } from '@mts-fe/utils';
  import { PreviewImage } from '@mts/components/Base';
  import type { CellProps } from '../../types/table';

  defineOptions({
    name: 'RenderImage',
    inheritAttrs: false,
  });

  interface ImageColumnRender {
    textKey?: string;
    text?: string | string[];
  }
  const props = withDefaults(defineProps<CellProps & { render: ImageColumnRender }>(), {});
  const getRenderProps = (render = props.render, record = props.record) => {
    const img = render.textKey
      ? record[render.textKey] || render.textKey
      : render.text || record[props.column.dataIndex!.toString()!] || '';

    const imageList = isArray(img) ? img : img.split(',');
    return omit({ ...render, imageList }, ['text', 'textKey']);
  };

  const attrs = useAttrs();
  const getBindValue = computed(() => {
    return { ...attrs, ...getRenderProps() };
  });
</script>
